<template>
<body class="home-page page basicpage light-theme">

    <div id="oc-wrapper" class="oc-container-v2">
        <header class="header-v2 header-v2-cn" id="header-v2" style="display: block;">

            <Head></Head>
        </header>
        <section id="oc-container" class="oc-container-v2">

            <div>

            </div>

            <div class="root responsivegrid">

                <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">

                    <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">

                        <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">

                            <div class="newproductlistbanner parbase aem-GridColumn aem-GridColumn--default--12">

                                <main class="product-main_v2-3 product-main_v2-3-cn">
                                    <section class="product-recommond">
                                        <div class="product-type">

                                            <div class="product-header tab-warp-dom" id="product-header">
                                                <div class="border-box">
                                                    <div class="header-box">
                                                        <p class="header-box-title" style="padding-top:0px">
                                                            <span>解决方案</span>
                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="nav-header-box header-box">
                                                    <!-- <ul class="nav-header-list">

                                                        <li class="active" data-type="all_item1">
                                                        </li>
                                                        <li data-type="all_item2"></li>
                                                    </ul> -->

                                                </div>
                                            </div>
                                            <div class="solution-list">
                                                <div class="solution-item" v-for="(d,i) in list" :key="i">
                                                    <router-link :to="'/solution-info/'+d.id" class="solution-img-link">
                                                        <picture>
                                                            <source :srcset="baseUrl + d.imgPathM" media="(max-width: 767px)" type="image/webp">
                                                            <source :srcset="baseUrl + d.imgPathM" media="(max-width: 767px)">
                                                            <source :srcset="baseUrl + d.imgPath" type="image/webp">
                                                            <img :src="baseUrl + d.imgPath" class="solution-img" :alt="d.name" />
                                                        </picture>
                                                    </router-link>
                                                    <div class="solution-details">
                                                        <div class="solution-name">
                                                            <router-link :to="'/solution-info/'+d.id">{{ d.name }}</router-link>
                                                        </div>
                                                        <div class="solution-desc">{{ d.remark }}</div>
                                                        <div class="solution-action">
                                                            <span class="buy-btn btn" @click="toLink(d.id)">了解更多</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </main>

                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </section>

        <span>

            <section class="light-theme">
                <footer id="footer">
                    <Foot></Foot>
                </footer>
            </section>
        </span>

    </div>

</body>
</template>

<script>
import {
    solutionData,
    solutionInfo
} from '@/request/api'
import Head from '../../components/heads.vue'
import Foot from '../../components/footer.vue'
export default {
    components: {
        Head,
        Foot
    },
    data() {
        return {
            list: [],
            baseUrl: "https://www.inrunonline.com/api/sys/common/static/"
        }
    },
    created() {
            solutionData().then((res) => {
                this.list = res.result;
                if (this.list && this.list.length >= 3) {
                    // 删除索引为2的元素(第三个)，并拿到这个元素
                    const thirdItem = this.list.splice(2, 1)[0];
                    // 把这个元素插入到数组开头(索引0)
                    this.list.unshift(thirdItem);
                }
            })
    },
    methods :{
        toLink(id){
            solutionInfo({id : id}).then((res) => {
                let data = res.result;
                if(data && data.content){
                    this.$router.push({
                        name:'solutionInfo',
                        params:{
                            id:id
                        }
                    })
                   
                }
            })
        }
    }
}
</script>

<style>
body.app-mode .cp-site-language-tip {
    display: none !important;
}

body.app-mode .cp-notice-bar {
    display: none !important;
}

body.app-mode #oc-header {
    display: none !important;
}

body.app-mode .new-header {
    display: none !important;
}

body.app-mode #header-v2 {
    display: none !important;
}

body.app-mode #footer {
    display: none !important;
}

body.app-mode #oc-container {
    padding-top: 0 !important;
    margin-top: 0 !important;
}

body.app-mode #oc-wrapper {
    padding-top: 0 !important;
}
</style>
<style>
    .oh-nav-pcseek {
        position: relative;
        z-index: 999;
    }

    /* 导航购物车图标 */
    @media(max-width: 767.98px) {
        body #footer .contact .contact-tab .tab-card .tab-card-wrap {
            padding-left: 0;
        }
    }
</style>
<style>
#oc-header .oh-nav-submenus-wrapper .pc-nav-series-products .oh-nav-series-product-list .swiper-slide .pTitle {
    max-width: 200px;
}

.header-v2 .header-main-pc .header-right .search::before,
.header-v2 .header-main-mo .header-menu .search::before {
    content: '';
    display: none;
}
</style>

<style>
    #footer nav dl {
        width: 200px
    }

    @media (max-width: 767.98px) {
        #footer nav dl {
            width: 100%
        }
    }

    @media (max-width: 1024px) {
        body.clean-theme #oc-container {
            margin-top: -50px;
        }

        .header-v2 .header-main-mo .header-menu.search-show {
            overflow-x: unset;
        }

        .header-v2 .header-main-mo .header-menu.search-hide {
            overflow-x: hidden;
        }
    }
</style>
<style>
    @media screen and (max-width: 768px) {

        body.support-home-page.show-cookie-tip .sow_black,
        body.support-page-stand.show-cookie-tip .sow_black,
        body.support-page.show-cookie-tip .sow_black {
            bottom: .64rem !important;
        }

        .support-home-page .sow_black,
        .support-page-stand .sow_black,
        .support-page .sow_black {
            bottom: 12px !important;
        }

        .oh-nav-mbseek .user-info .user-pic img {
            width: 100%;
        }
    }

    @media only screen and (min-width: 1441px) and (max-width: 1919px) {

        body.support-home-page.show-cookie-tip .sow_customerIcon,
        body.support-page-stand.show-cookie-tip .sow_customerIcon,
        body.support-page.show-cookie-tip .sow_customerIcon {
            transition: bottom .3s;
            bottom: 125px !important;
        }

        body.support-home-page .sow_customerIcon,
        body.support-page-stand .sow_customerIcon,
        body.support-page .sow_customerIcon {
            transition: bottom .3s;
            bottom: 68px !important;
        }
    }

    @media only screen and (min-width: 1920px) and (max-width: 999999px) {

        body.support-home-page.show-cookie-tip .sow_customerIcon,
        body.support-page-stand.show-cookie-tip .sow_customerIcon,
        body.support-page.show-cookie-tip .sow_customerIcon {
            transition: bottom .3s;
            bottom: 142px !important;
        }

        body.support-home-page .sow_customerIcon,
        body.support-page-stand .sow_customerIcon,
        body.support-page .sow_customerIcon {
            transition: bottom .3s;
            bottom: 85px !important;
        }
    }
</style>

<style>
.solution-list {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
}

.solution-item {
    display: flex;
    align-items: flex-start;
    padding: 30px 0;
    border-bottom: 1px solid #e8e8e8;
}

.solution-item:last-child {
    border-bottom: none;
}

.solution-img-link {
    flex-shrink: 0;
    width: 420px;
    height: 210px;
    margin-right: 40px;
    display: block;
    overflow: hidden;
    border-radius: 6px;
}

.solution-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.solution-details {
    flex: 1;
    min-width: 0;
}

.solution-name {
    margin-bottom: 12px;
}

.solution-name a {
    color: #006F6B;
    font-size: 18px;
    font-weight: 600;
    text-decoration: none;
    line-height: 1.4;
}

.solution-name a:hover {
    text-decoration: underline;
}

.solution-desc {
    color: #666;
    font-size: 14px;
    line-height: 1.8;
    margin-bottom: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.solution-action .buy-btn {
    display: inline-block;
    padding: 8px 24px;
    border: 1px solid #006F6B;
    color: #006F6B;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
}

.solution-action .buy-btn:hover {
    background: #006F6B;
    color: #fff;
}

@media (max-width: 767px) {
    .solution-item {
        flex-direction: column;
        padding: 20px 0;
    }

    .solution-img-link {
        width: 100%;
        height: auto;
        aspect-ratio: 2 / 1;
        margin-right: 0;
        margin-bottom: 16px;
    }

    .solution-name a {
        font-size: 16px;
    }
}
</style>
